import {
  AppContainer,
  ConfigWrapper,
  SummaryContainer,
} from "components/styled-components/generic";
import { FC } from "react";
import { Car, Charger } from "shared-types";
import { BatteryDetails } from "./battery-details";
import { CalculationResult } from "./calculation-result";
import { Chargers } from "./chargers";
import cls from "./index.module.css";

export interface BatteryChargeProps {
  carToShow: Car;
  batteryLevel: number[];
  setBatteryLevel: (lvl: number[]) => void;
  batteryChargingTime: string | undefined;
  selectedCharger: Charger;
  setSelectedCharger: (charger: Charger) => void;
  range: number | null | undefined;
}

const BatteryCharge: FC<BatteryChargeProps> = ({
  carToShow,
  batteryLevel,
  setBatteryLevel,
  batteryChargingTime,
  selectedCharger,
  setSelectedCharger,
  range,
}) => {
  return (
    <AppContainer>
      <SummaryContainer>
        <CalculationResult
          batteryLevel={batteryLevel}
          batteryChargingTime={batteryChargingTime}
          range={range}
        />
        <ConfigWrapper>
          <div className={cls["tile"]}>
            <BatteryDetails
              carModel={carToShow}
              batteryLevel={batteryLevel}
              setBatteryLevel={setBatteryLevel}
            />
          </div>
          <div className={cls["tile"]}>
            <Chargers
              selectedCharger={selectedCharger}
              setSelectedCharger={setSelectedCharger}
            />
          </div>
        </ConfigWrapper>
      </SummaryContainer>
    </AppContainer>
  );
};

export default BatteryCharge;
